export default "__VITE_ASSET__79xiwChp__"